import { render, staticRenderFns } from "./FormLocate.vue?vue&type=template&id=7c87c328&scoped=true"
import script from "./FormLocate.vue?vue&type=script&lang=js"
export * from "./FormLocate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c87c328",
  null
  
)

export default component.exports